// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"463":"166e5523","951":"d482f40d","975":"e707cc79"}[chunkId] + ".chunk.css";
};